import * as React from "react";
import { Plus } from "lucide-react";

import { Button } from "./button";
import { cn } from "../../lib/utils";

/**
 * Thin wrapper over `Button` (spec §5.21). This is the one primary action a
 * toolbar is allowed — a 28px accent button, not a 40px pill.
 */
export interface ToolbarCreateButtonProps {
  onClick?: () => void;
  label?: string;
  className?: string;
}

const ToolbarCreateButton = React.forwardRef<
  HTMLButtonElement,
  ToolbarCreateButtonProps
>(({ onClick, label = "New Task", className }, ref) => (
  <Button
    ref={ref}
    type="button"
    size="sm"
    onClick={onClick}
    className={cn("shrink-0", className)}
  >
    <Plus aria-hidden="true" />
    {label}
  </Button>
));
ToolbarCreateButton.displayName = "ToolbarCreateButton";

export { ToolbarCreateButton };
